import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { formatDate, Get_Api } from "../API_URL";

const BlogDetail = () => {

    const { id } = useParams();

    const [BlogDetail, setBlogDetail] = useState({});
    const [IsUploading, setIsUploading] = useState(false);

    const Get_A_Blog = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api(`api/admin/GetABlog/${id}`);
            setBlogDetail(response?.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        Get_A_Blog();
    }, [id]);



    return (
        <>
            {IsUploading && (
                <div className="loading-text">Loading...</div>
            )}
            <div className="max-w-4xl mx-auto p-1 mt-[50px]">
                <div className="flex justify-center">
                    <img
                        src={BlogDetail?.Image}
                        alt="Blog"
                        className="w-full max-h-[400px] object-cover rounded-lg shadow-md"
                    />
                </div>

                <h1 className="text-3xl font-bold text-gray-800 mt-6 text-center">
                    {BlogDetail?.Heading}
                </h1>

                <p className="text-gray-600 text-lg mt-3 text-center">
                    {BlogDetail?.Description}
                </p>

                <div className="flex justify-start gap-3 mt-4">
                    <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm">{BlogDetail?.Tag}</span>
                </div>
                <p className="text-gray-600 text-lg mt-3 ">
                    Date - {formatDate(BlogDetail?.createdAt)}
                </p>
                <div className="mt-6 text-gray-700 text-lg leading-relaxed">
                    <p>
                        <div
                            dangerouslySetInnerHTML={{ __html: BlogDetail?.Details }}
                            style={{ color: "black", fontSize: "18px", lineHeight: "1.6" }}
                        ></div>
                    </p>
                </div>
            </div>
        </>
    );
};

export default BlogDetail;
